var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-text',[_c('router-link',{attrs:{"to":{ name: 'Page', params: { uuid: _vm.page.UUID } }}},[_vm._v(_vm._s(_vm.page.Name))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }